// Contact and social links used across the site. Update them here only.
export const PHONE_DISPLAY = "+1 (905) 622 1221";
export const WHATSAPP_URL = "https://wa.me/19056221221";
export const FACEBOOK_URL = "https://www.facebook.com/infoSCinternational";

// ICEF Agency Status account number, shown as the accreditation badge in the
// footer. Verify at https://api2.icef.com/public/account/certificate/<id>
export const ICEF_ACCOUNT_ID = "0809";

// Web app URL from the Google Apps Script deployment
// (see google-apps-script/SETUP.md). Applications can't be sent until it's set.
export const APPLY_FORM_ENDPOINT = "";
